import React, {FunctionComponent, PropsWithChildren} from "react";
import {styled, Text} from "@reside/ui";

export const MenuGroup = styled.div`
  margin-bottom: 24px;
`;

const MenuGroupTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const MenuGroupTitle: FunctionComponent<PropsWithChildren<{}>> = ({
  children,
}) => (
  <MenuGroupTitleContainer>
    <Text fontWeight="bold" fontSize={3} lineHeight="20px">
      {children}
    </Text>
  </MenuGroupTitleContainer>
);
